import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_roen_9: FaireProductEntity = {
  token: "legacy_prod_roen-9",
  type: "product",
  name: "Nueve Leones",
  brandName: "ROEN",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/b580ba774deb43fbd14d336eb7cd2582f2000b42a783b539d43de782a50539d8.webp",
  priceDollars: 19,
  msrpDollars: 38,
  freeShipping: true,
  brandAvatarUrl: "/images/ROEN/Brand%20Page/roen-avatar.webp",
  weight: 0.5,
  dimensions: {
    width: 3,
    height: 4,
    depth: 2,
  },
  brandToken: "catalog_brand_roen",
  description: "Premium candle from ROEN.",
  categoryTokens: ["cat_food-snacks"],
  tags: ["candles", "home fragrance", "premium"],
  inStock: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
